import { TeamName } from './TeamName';

export type ChallengeType = 'ABS' | 'ACS';

// TODO: These should be fetched from the game rule settings
export const ABS_ALLOWED_INCORRECT_CHALLENGES = 3;
export const ACS_ALLOWED_INCORRECT_CHALLENGES = 1;

export const INITIAL_TEAM_CHALLENGES: PitchChallengesCount = { challenges: 0, overturned: 0, upheld: 0 };

export enum PITCH_CHALLENGE_RESULT {
  OVERTURNED = 'OVERTURNED',
  UPHELD = 'UPHELD',
}

export type PitchChallenge = {
  playId: string;
  inning: number;
  halfInning: string;
  batterName: string;
  pitcherName: string;
  playResult: string;
  challengeResult: PITCH_CHALLENGE_RESULT;
  challengeTeamId: number;
};

export type PitchChallengesCount = {
  challenges: number;
  overturned: number;
  upheld: number;
};

export type GamePitchChallenges = {
  gamePk: number;
  awayTeam: TeamName;
  awayTeamId: number;
  homeTeam: TeamName;
  homeTeamId: number;
  pitchChallenges: PitchChallenge[];
};
export interface GamePitchChallengeRow {
  gamePitchChallenges: GamePitchChallenges;
  expanded: boolean;
}
